import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { Typography } from '@cp/ds/src/components/typography';
import { Image } from '@cp/ds/src/components/image';
import { ImageAsset } from '@common/model/resource/image';
import { useIsMobile } from '@cp/ds/src/hooks';
import { useIsLoggedIn } from '@cp/entities/currentUser';
import { MOBILE_BREAKPOINT_THRESHOLD } from '@cp/ds';
import { LoginButton } from 'src/features/auth';
// eslint-disable-next-line import/no-duplicates
import BgImageDesktopImage from '../../assets/images/workForYouBgDesktop.png';
// eslint-disable-next-line import/no-duplicates
import BgImageDesktopWebp from '../../assets/images/workForYouBgDesktop.png?format=webp';
// eslint-disable-next-line import/no-duplicates
import BgImageMobileImage from '../../assets/images/workForYouBgMobile.png';
// eslint-disable-next-line import/no-duplicates
import BgImageMobileWebp from '../../assets/images/workForYouBgMobile.png?format=webp';
import { WorkForYouProps } from './types';

const imageAssetDesktop: ImageAsset = {
  base: BgImageDesktopImage,
  webp: BgImageDesktopWebp,
};

const imageAssetMobile: ImageAsset = {
  base: BgImageMobileImage,
  webp: BgImageMobileWebp,
};

export const WorkForYou: React.FC<WorkForYouProps> = ({ header, content }) => {
  const isLoggedIn = useIsLoggedIn();
  const isMobile = useIsMobile();

  return (
    <Box
      sx={{
        position: 'relative',
        py: isMobile ? 2 : 5,
        pb: isMobile ? (isLoggedIn ? 7 : 2) : isLoggedIn ? 10 : undefined,
      }}
    >
      <Image
        alt=""
        asset={isMobile ? imageAssetMobile : imageAssetDesktop}
        sx={{
          position: 'absolute',
          ...(isMobile
            ? {
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                minHeight: '100%',
                minWidth: '100vw',
              }
            : {
                top: 0,
                left: '60%',
                transform: 'translateX(-50%)',
                height: '100%',
                minHeight: '100%',
              }),
          zIndex: 0,
        }}
      />

      <Box sx={{ position: 'relative', zIndex: 1 }}>{header}</Box>

      <Box sx={{ position: 'relative', zIndex: 1, maxWidth: 247 }}>
        {content}

        <Typography component="div" sx={{ mt: 1, mb: 2.5 }} variant="body bold">
          Здесь вы можете найти работу, подходящую вам
        </Typography>

        {!isLoggedIn && (
          <LoginButton color="gray" variant="primary">
            Войти или зарегистрироваться
          </LoginButton>
        )}
      </Box>
    </Box>
  );
};
